export default {
    breadcrumbs: {
        referrals: 'Referrals',
        received: 'Received',
        made: 'Made',
    },

    titles: {
        received: 'Referrals received',
        made: 'Referrals made',
    },

    pool_titles: {
        received: 'Pool received',
        made: 'Pool made',
    },

    controls: {
        status: 'View',
        filters: 'Filter',
        pagination: 'Show',
        number_per_page: '{n} per page',
        search: 'Search by provider or patient name',
    },

    statuses: {
        open: 'Open',
        closed: 'Completed',
        all: 'All',
    },

    headings: {
        from: 'From',
        to: 'To',
        patient: 'Patient',
        scheduled_for: 'Scheduled for',
        created_at: 'Created on',
        received_at: 'Received at',
        status: 'Status',
        diagnosis: 'Diagnosis',
    },

    buttons: {
        view_details: 'View details',
        view_referral: 'View referral',
        respond: 'Respond',
        add_notes: 'Add report',
        show_more: 'Show more',
        propose_new_slots: 'Propose new slots',
        select_time_slot: 'Select time slot',
    },

    warnings: {
        reschedule: {
            hintTitle: ' ',
            text: 'Falls in within the next 24 hours',
        },
    },

    locations: {
        main: 'Main Location',
    },

    patient: {
        dob: 'DOB',
        tooltip: 'Patient information will be disclosed after HIPPA Privacy Rule is accepted',
    },

    filters: {
        title: 'Show referrals with status',
        pending_confirmation: 'Pending confirmation',
        patient_visit_pending: 'Patient visit pending',
        pending_insurance_auth: 'Pending ins. authorization',
        pending_consultation_report: 'Pending consultation report',
        to_be_rescheduled: 'To be rescheduled',
        out_of_availability: 'Out of actual availability',
        declined: 'Declined',
        cancelled: 'Cancelled',
        no_show: 'No show',
        completed: 'Completed',
    },

    empty_state: {
        no_referrals: 'There are no referrals at this time',
    },

    referrals_made: {
        heading: 'Referrals Made',
        subheading: 'Track referrals you`ve sent to other providers',
        view: ' View All',
        filter: 'Filters',
        made: '3 made referrals',
        id_made: 'REFERRED TO',
        id_received: 'REFERRING PROVIDER',
        patient_name: 'PATIENT',
        stage: 'STAGE',
        needed: 'WHAT`S NEEDED',
        timing: 'TIMING',
        typer: 'TYPE',
        action: 'ACTIONS',
        user_title: 'FJ',
        user_name: 'John Doe',
        provider_id: 'Provider ID: 12345',
        confirmation: 'Appointment confirmed',
        timings: 'Soon',
        type_direct: 'Direct',
        type_matched: 'Matched',
        detail: 'View Details',
        patient_request: 'Patient Appointment Requests',
        appointment_request: 'Manage appointment requests from patients',
        all: 'View All',
        received: 'Referrals Received',
        received_subtitle: 'Manage referrals from other providers',
        received_made: 'Made',
        received_referral: 'Received',
        Referrals_title: 'Referrals Made',
        track_title: 'Track referrals you`ve sent to other providers',
        track_sub_title: '{n} made referrals',
        filters: 'Filters',
        review: ' Review & accept',
        review_information: 'Request more information',
        pataint: 'PATIENT',
        prority: 'PRIORITY',
        request_type: 'REQUEST TYPE',
        pataint_for: 'REQUESTED TIME',
        confirm: 'Confirm appointment',
        unable: 'Unable to accommodate',
        detail_inform: ' Request more information',
        provider_received_referral: ' Provider Referrals',
        provider_received_request: 'Patient Requests',
        request_filters: '{n} appointment requests from patients',
        count: '1',
        counts: '2',
        tracks: 'Track',
        referrals_filters: '{n} received referrals',
        received_details: '0 received referrals',
        received_title: 'Received Referrals',
        received_sent: 'Referrals sent to you by patients',
        availability: 'Review patient history and confirm your availability',
        timings_today: 'Today',
        under_review: 'Under Reviw',
        medical_assessment: 'Complete medical assessment',
        awaiting_information: 'Awaiting information',
        overdue: 'Overdue',
        additional: 'Additional lab results needed from referring provider',
        awaiting_response: 'Awaiting response',
        schedeled: 'Scheduled',
        completed: 'Completed',
        specialist: ' Waiting for specialist to accept referral',
        neededs: 'No action needed',
        awaiting_confirmation: 'Awaiting your confirmation',
        confirms: 'Confirmed',
        new_request: 'New request',
        matched: 'Matched',
        reminder: 'Send reminder ',
        send_up: 'Send follow-up',
        view_patient_details: 'View patient details',
        send_message: 'Send message',
        reschedule: 'Reschedule',
        dob: 'DOB:',
        view_provider: 'View Provider',
        view_providers: 'View {n} Providers',
    },

    referral_modal: {
        head: 'Referral Details',
        date: 'Referral Date',
        timeline: 'Timeline',
        next: 'Next step',
        created: 'Referral received',
        assigned_provider: 'Assigned to provider',
        needed: "What's Needed",
        track: 'Track Progress',
        close: 'Close',
        last_acti: 'Last Activity:',
    },
}
